/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { getProduct, handleAddProduct, } from "../../Redux/ProductSlice";
import { getAllCategory, getAllVisibleTo, getCurrency } from "../../Redux/CommonSlice";
import ReactSelect from "../Common/ReactSelect";
import { FiPlusCircle } from "react-icons/fi";
import AddCategory from "../Common/AddCategory";
import { FaPlus } from "react-icons/fa6";
import { RiDeleteBinLine } from "react-icons/ri";
import { formatNumber } from "../Common/Common";

export default function AddProduct({ toggleModal, product }) {
  const dispatch = useDispatch();
  const [loadFist, setLoadFist] = useState(true);
  const { register, handleSubmit, setValue, formState: { errors }, clearErrors } = useForm();
  const storecommon = useSelector((state) => state.root.common);
  const modalTitle = product?.productID ? "Update Product" : "Add Product";

  const [selectedCurrency, setSelectedCurrency] = useState({ value: 63, label: "Indian Rupee(INR)", });
  const [selectedVisible, setselectedVisible] = useState(1);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [openCategoryModal, setOpenCategoryModal] = useState(false);
  const [allUnitPrice, setAllUnitPrice] = useState([{
    unitprice: 0, cost: 0, currencyID: selectedCurrency.value, currencyName: selectedCurrency.label,
  }]);

  useEffect(() => {
    if (loadFist) {
      dispatch(getCurrency({}));
      dispatch(getAllVisibleTo({}));
      dispatch(getAllCategory({}));
      setLoadFist(false);
    }
  }, [storecommon, loadFist]);

  useEffect(() => {
    if (product) {
      setValue("Name", product?.name);
      setValue("productCode", product?.productCode);
      setValue("Unit", product?.unit);
      setValue("UnitPrices", product?.unitPrice);
      setValue("Tax", product?.taxper);
      setValue("Currency", product?.priceType);
      setValue("Category", product?.category);

      if (product && product?.visibleToID) setselectedVisible({ label: product?.visibleName, value: product?.visibleToID, });
      if (product && product?.categoryID) setSelectedCategory({ label: product?.categoryName, value: product?.categoryID, });

      if (product?.productPrice?.length > 0) {
        console.log('product?.productPrice :>> ', product?.productPrice);
        setAllUnitPrice(product?.productPrice.map((x) => ({ unitprice: x?.unitprice, cost: 0, currencyID: x?.currencyID, directCost: 0, currencyName: x?.currencyName })))
      }
    }
  }, [product]);

  const handleVisibleChange = (option) => { setselectedVisible(option); };

  const currencyOptions = storecommon && storecommon?.getCurrency?.length > 0 ? storecommon?.getCurrency?.map((item) => ({
    value: item?.value,
    label: item?.text,
    icon: item?.type,
    isDisabled: allUnitPrice.some((x) => x?.currencyID === item?.value),
  })) : [{ value: "", label: "Not Found" }];

  useEffect(() => {
    if (currencyOptions?.length > 0) {
      const indianRupee = currencyOptions?.find((x) => { return x?.label === "Indian Rupee(INR)" && !x?.isDisabled })
      const initialCurrency = indianRupee || currencyOptions?.find(option => !option?.isDisabled) || currencyOptions[0];
      setSelectedCurrency(initialCurrency)
    }
  }, [storecommon?.getCurrency]);

  const handleFieldChange = (index, fieldName, value, option) => {
    if (fieldName === 'unitprice') {
      const rawValue = value.replace(/[^0-9]/g, '');
      value = rawValue
    }

    const updatedUnitPrices = [...allUnitPrice];
    updatedUnitPrices[index] = { ...updatedUnitPrices[index], [fieldName]: value };
    if (fieldName === 'currencyID') {
      updatedUnitPrices[index].currencyName = option?.label ? option?.label : 'Indian Rupee';
    }
    setAllUnitPrice(updatedUnitPrices);
  };

  const onSubmit = (data) => {
    const Params = {
      productID: product && product.productID ? product.productID : 0,
      name: data?.Name,
      productCode: data?.productCode,
      categoryID: selectedCategory?.value,
      unit: data?.Unit,
      unitPrice: data?.UnitPrices,
      taxper: data?.Tax,
      visibleToID: selectedVisible.value,
      isactive: true,
      "productPrice": allUnitPrice
    };

    try {
      dispatch(handleAddProduct(Params)).then((res) => {
        if (res?.payload?.status === true) {
          dispatch(getProduct({}));
          toggleModal();
          setSelectedCurrency("");
        }
      });
    } catch (error) {
      console.log("error", error);
    }
  };

  return (
    <>
      <div
        id="default-modal"
        tabIndex="-1"
        aria-hidden="true"
        className="lead-modal-backdrop"

      >
        <div className="lead-modal-shell">
          <div className="lead-modal-card">
            <div className="lead-modal-header">
              <div>
                <h3 className="lead-modal-title">{modalTitle}</h3>
              </div>
              <AiOutlineCloseCircle
                className="lead-modal-close"
                onClick={toggleModal}
              />
            </div>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="lead-modal-body">
                <div className="lead-modal-grid vertical-scroll-inner">
                  <div className="lead-modal-section">
                    <div className="lead-modal-section-header">
                      <span className="lead-modal-section-dot" />
                      <h4>Product details</h4>
                    </div>
                    <div className="lead-modal-section-content">
                      <div className="lead-modal-field">
                        <label htmlFor="Name" className="lead-modal-label">Name</label>
                        <input
                          type="text"
                          {...register("Name", { required: "Product Name is Required" })}
                          name="Name"
                          id="Name"
                          className="lead-modal-input capitalize"
                          placeholder="Enter Product Name"
                        />
                        {errors.Name && <span className="lead-modal-error">{errors.Name.message}</span>}
                      </div>
                      <div className="lead-modal-field">
                        <label htmlFor="productCode" className="lead-modal-label">Product code</label>
                        <input
                          type="number"
                          min="0"
                          {...register("productCode")}
                          className="lead-modal-input"
                          placeholder="Enter Product code"
                        />
                      </div>
                      <div className="lead-modal-field">
                        <label htmlFor="Unit" className="lead-modal-label">Quantity</label>
                        <input
                          type="number"
                          min="0"
                          {...register("Unit", { required: "Unit is Required" })}
                          name="Unit"
                          id="Unit"
                          className="lead-modal-input"
                          placeholder="Enter Unit"
                        />
                        {errors?.Unit && <span className="lead-modal-error">{errors.Unit.message}</span>}
                      </div>
                      <div className="lead-modal-field">
                        <label htmlFor="Tax" className="lead-modal-label">Tax %</label>
                        <input
                          type="number"
                          min="0"
                          {...register("Tax", { required: "Tax is Required" })}
                          name="Tax"
                          id="Tax"
                          className="lead-modal-input"
                          placeholder="Enter Tax %"
                        />
                        {errors.Tax && <span className="lead-modal-error">{errors.Tax.message}</span>}
                      </div>
                      <div className="lead-modal-field">
                        <label htmlFor="Category" className="lead-modal-label">Category</label>
                        <div className="lead-modal-inline-control">
                          <ReactSelect
                            selectedValue={selectedCategory}
                            options={storecommon && storecommon?.getCategorys.length > 0
                              ? storecommon?.getCategorys.map((item) => ({
                                value: item?.categoryID,
                                label: item?.categoryName,
                              }))
                              : [{ value: "", label: "Not Found" }]}
                            handleSelectChange={(option) => setSelectedCategory(option)}
                          />
                          <FiPlusCircle
                            size={28}
                            className="lead-modal-add-label"
                            onClick={() => setOpenCategoryModal(true)}
                          />
                        </div>
                      </div>
                      <div className="lead-modal-field">
                        <label htmlFor="Visible to" className="lead-modal-label">Visible to</label>
                        <ReactSelect
                          selectedValue={selectedVisible}
                          options={storecommon && storecommon?.getAllVisibleTo.length > 0
                            ? storecommon?.getAllVisibleTo.map((item) => ({
                              value: item?.value,
                              label: item?.text,
                            }))
                            : [{ value: "", label: "Not Found" }]}
                          handleSelectChange={handleVisibleChange}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="lead-modal-section">
                    <div className="lead-modal-section-header">
                      <span className="lead-modal-section-dot lead-modal-section-dot-blue" />
                      <h4>Pricing details</h4>
                    </div>
                    <div className="lead-modal-section-content">
                      {allUnitPrice?.map((item, index) => (
                        <div className="lead-modal-row" key={index}>
                          <div className="lead-modal-field">
                            <label htmlFor={`UnitPrices_${index}`} className="lead-modal-label">Unit Prices</label>
                            <input
                              type="text"
                              {...register(`UnitPrices_${index}`, { required: "Unit Price is Required" })}
                              name={`UnitPrices_${index}`}
                              id={`UnitPrices_${index}`}
                              className="lead-modal-input"
                              placeholder="Enter Unit prices"
                              min="0"
                              value={formatNumber(item?.unitprice || '')}
                              onChange={(e) => {
                                handleFieldChange(index, 'unitprice', e.target.value);
                                clearErrors(`UnitPrices_${index}`);
                              }}
                            />
                            {errors[`UnitPrices_${index}`] && <span className="lead-modal-error">{errors[`UnitPrices_${index}`]?.message}</span>}
                          </div>
                          <div className="lead-modal-field">
                            <label htmlFor={`Currency_${index}`} className="lead-modal-label">Currency</label>
                            <div className="flex items-center gap-2">
                              <ReactSelect
                                Clearable={false}
                                selectedValue={storecommon?.getCurrency?.find(x => x?.value === item?.currencyID)
                                  ? { value: item?.currencyID, label: item?.currencyName, icon: storecommon?.getCurrency?.find(x => x?.value === item?.currencyID)?.type }
                                  : null}
                                options={currencyOptions}
                                handleSelectChange={(option) => handleFieldChange(index, 'currencyID', option?.value, option)}
                              />
                              <RiDeleteBinLine
                                className="lead-modal-delete"
                                size={20}
                                onClick={() => {
                                  const updatedQuestions = allUnitPrice.filter((_, i) => i !== index);
                                  setAllUnitPrice(updatedQuestions);
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      ))}

                      <button
                        type="button"
                        className="lead-modal-add-btn"
                        onClick={() => {
                          if (currencyOptions?.length > 0) {
                            const indianRupee = currencyOptions?.find((option) => option?.value === 63 && !option?.isDisabled);
                            const initialCurrency = indianRupee || currencyOptions?.find(option => !option?.isDisabled) || currencyOptions[0];
                            setAllUnitPrice([...allUnitPrice, { unitprice: 0, cost: 0, currencyID: initialCurrency?.value, currencyName: initialCurrency?.label }]);
                          }
                        }}
                      >
                        <FaPlus />
                        <span>Price</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="lead-modal-footer">
                <button
                  type="button"
                  className="px-4 py-2 border border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800 text-sm font-semibold rounded-lg transition-colors cursor-pointer mr-1"
                  onClick={toggleModal}
                >
                  Close
                </button>

                <button
                  type="submit"
                  className="px-5 py-2 bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold rounded-lg shadow-md hover:shadow-lg transition-all duration-200 cursor-pointer"
                >
                  {product?.productID ? "Update" : "Save"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {openCategoryModal && (<AddCategory setOpenCategoryModal={setOpenCategoryModal} />)}
    </>
  );
}
